export default __webpack_public_path__ + "static/media/Gallery.3037c9fd.png";